import Color from '../Color.mjs'
import superMeta from '../_ARCH/metaArchNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.GOLD,
    alias: '功能模型',
    // 总图节点别名：按项目子类型覆盖（需求模型B）
    aliasBySubType: {RMB: '系统功能'},
    archName: '功能地图',
    archUrl: '/ProjectSfMap',
    detailUrl: '/FaDetail',
    detailIdProp: 'faId',
    listUrl: 'FaList',
    mapProp: 'faMap',
    moduleType: 'FM',
    name: '功能结构',
    type: 'FA',
}
